<template>
    <div ref="chart"></div>
  </template>
  
  <script >
  import * as d3 from 'd3';
  export default {
    name: 'BarChart',
    props: {
      domain: {
        type: Array,
        required: true,
      },
      width:{
        type: Number,
        default:500
      },
      height:{
        type: Number,
        default:300
      },
    },
    mounted() {
      this.createChart();
    },
    watch:{
      domain(){
        this.updateChart()
        return
      }
    },
    methods: {
      createChart() {
        const domain = this.domain;
        const margin = { top: 20, right: 30, bottom: 40, left: 60 },
          width = this.width - margin.left - margin.right,
          height = this.height;

        this.svg = d3.select(this.$refs.chart)
          .append('svg')
          .attr('class', 'svg-x-axis')
          .attr("viewBox", `0 0 ${width + margin.left + margin.right} ${height}`)
          //.attr('width', width + margin.left + margin.right)
          //.attr('height', height + margin.top + margin.bottom)
          .append('g')
          .attr('transform', `translate(${margin.left},${height})`);

        this.x = d3.scaleLinear()
          .domain(domain)
          .nice()
          .range([0, width]);


        this.svg.append('g')
          .attr('class', 'x-axis')
          .call(d3.axisTop(this.x)
          .ticks(30));


      },
      updateChart() {
        const domain = this.domain;
        const margin = { top: 20, right: 30, bottom: 40, left: 60 }
        const width = this.width - margin.left - margin.right;
        const height = this.height;

        d3.select("svg-x-axis")
          .attr("viewBox", `0 0 ${width+ margin.left + margin.right} ${height}`)
         // .attr('height', height + margin.top + margin.bottom)

        // Actualizar la escala Y con los nuevos datos
        this.x.domain(domain)
      }
    }
  };
  </script>
  <style scoped>
  .bar {
    fill: steelblue;
  }
  .x-axis path,
  .x-axis line,
  .y-axis path,
  .y-axis line {
    shape-rendering: crispEdges;
  }
  .x-axis text,
  .y-axis text {
    text-anchor: end;
    font-size: 12px;
  }
  </style>